export function isRural() {
  if (window.location.href.indexOf("rural") != -1 || window.location.href.indexOf("rurais") != -1) {
    return true;
  }
  return false;
}